(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealSelector = [
    '#MainContent > .shopify-section',
    '#MainContent .rhm-bar',
    '#MainContent .rhm-product',
    '#MainContent .product-information__media',
    '#MainContent .product-information__details',
    '#MainContent .rh-product-story > *',
    '#MainContent .cart-items__table-row',
    '#MainContent [class*="cart-page"] > *',
    'footer .rh-footer__top > *'
  ].join(',');

  let revealObserver;

  if (!reducedMotion && 'IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('rh-revealed');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
  }

  function bindReveals(root = document) {
    if (reducedMotion || !revealObserver || !root.querySelectorAll) return;

    const nodes = Array.from(root.querySelectorAll(revealSelector));
    const unique = Array.from(new Set(nodes));

    unique.forEach((element, index) => {
      if (element.dataset.rhRevealBound === 'true') return;
      element.dataset.rhRevealBound = 'true';

      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9) {
        element.classList.add('rh-revealed');
        return;
      }

      element.classList.add('rh-reveal');
      const stagger = Math.min((index % 3) * 65, 130);
      element.style.setProperty('--rh-reveal-delay', `${stagger}ms`);
      revealObserver.observe(element);
    });
  }

  const instructionDrafts = window.__rebelaInstructionDrafts || {};
  window.__rebelaInstructionDrafts = instructionDrafts;

  function createInstructionPanel(form, productId) {
    const details = document.createElement('details');
    details.className = 'rh-order-instructions';
    details.dataset.rhOrderInstructions = 'true';

    const summary = document.createElement('summary');

    const title = document.createElement('span');
    title.className = 'rh-order-instructions__title';
    title.textContent = 'ORDER INSTRUCTIONS';

    const optional = document.createElement('span');
    optional.className = 'rh-order-instructions__optional';
    optional.textContent = 'OPTIONAL';

    const plus = document.createElement('span');
    plus.className = 'rh-order-instructions__plus';
    plus.setAttribute('aria-hidden', 'true');

    summary.append(title, optional, plus);

    const panel = document.createElement('div');
    panel.className = 'rh-order-instructions__panel';

    const lead = document.createElement('p');
    lead.className = 'rh-order-instructions__lead';
    lead.textContent = 'Add sizing or order notes for this piece before adding it to your bag.';

    const textarea = document.createElement('textarea');
    const id = `RhOrderInstructions-${productId.replace(/[^a-zA-Z0-9_-]/g, '-')}`;
    textarea.id = id;
    textarea.name = 'properties[Order instructions]';
    textarea.rows = 4;
    textarea.maxLength = 500;
    textarea.autocomplete = 'off';
    textarea.placeholder = 'Sizing or order notes only…';
    textarea.value = instructionDrafts[productId] || '';

    const label = document.createElement('label');
    label.className = 'rh-order-instructions__label';
    label.htmlFor = id;
    label.textContent = 'Order instructions';

    const note = document.createElement('p');
    note.className = 'rh-order-instructions__note';
    note.id = `${id}-note`;
    note.textContent = 'Please don’t include payment-card details, passwords, or other sensitive information.';
    textarea.setAttribute('aria-describedby', note.id);

    textarea.addEventListener('input', () => {
      instructionDrafts[productId] = textarea.value;
    });

    panel.append(lead, label, textarea, note);
    details.append(summary, panel);
    return details;
  }

  function injectOrderInstructions(root = document) {
    if (!document.body || !document.body.classList.contains('template-product')) return;

    root.querySelectorAll('product-form-component form').forEach((form) => {
      if (form.querySelector('[data-rh-order-instructions]')) return;

      const buttons = form.querySelector('.product-form-buttons');
      if (!buttons) return;

      const component = form.closest('product-form-component');
      const productId = component?.dataset.productId || window.location.pathname;
      const panel = createInstructionPanel(form, productId);

      const addButton = buttons.querySelector('.add-to-cart-button');
      const anchor = addButton ? Array.from(buttons.children).find((child) => child.contains(addButton)) : null;
      buttons.insertBefore(panel, anchor || null);
    });
  }

  function initialize(root = document) {
    bindReveals(root);
    injectOrderInstructions(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  const main = document.getElementById('MainContent');
  if (main && 'MutationObserver' in window) {
    let frame = 0;
    const mutationObserver = new MutationObserver(() => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => initialize(main));
    });
    mutationObserver.observe(main, { childList: true, subtree: true });
  }
})();
